import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { TaraFloatingActionButton } from '../components/features/Tara';
import { actions } from '../actions/tara';
import { getTaraHasAnsweredSurvey } from '../reducers/tara/hasAnsweredSurvey';
import { getTaraHasMadeIntroduction } from '../reducers/tara/hasMadeIntroduction';
import { getIsFetching } from '../reducers/tara/isFetching';
import { getStatus } from '../reducers/tara/status';
import { getTaraSurvey } from '../reducers/tara/survey';

class TaraFloatingActionButtonContainer extends React.PureComponent {
  componentDidMount() {
    if (!this.props.survey) {
      this.props.taraGetSurveyRequest();
    }
  }

  handleClick = (e) => {
    this.props.taraSetIsViewingSurvey(true);
  };

  render() {
    return (
      <TaraFloatingActionButton
        {...this.props}
        onClick={this.handleClick}
      />
    );
  }
}

const getState = (state, ownProps) => ({
  hasAnsweredSurvey: getTaraHasAnsweredSurvey(state),
  survey: getTaraSurvey(state),
  ...ownProps,
});

const getActions = dispatch => bindActionCreators({
  taraSetIsViewingSurvey: actions.taraSetIsViewingSurvey,
  taraGetSurveyRequest: actions.taraGetSurveyRequest,
  taraPostSurveyRequest: actions.taraPostSurveyRequest,
}, dispatch);

export default connect(getState, getActions)(TaraFloatingActionButtonContainer);



// WEBPACK FOOTER //
// ./src/containers/TaraFloatingActionButtonContainer.js